import { Accordion, Button } from 'react-bootstrap'
import { CustomerActivityRow } from '~/pages/company/CustomerActivityRow'
import React, { useCallback, useRef, useState } from 'react'
import moreIcon from '@web/images/profile/more-icon-light.svg'
import { elementClicked } from '~/common/EventLogger'
import { ApolloError } from '@apollo/client'
import { PostImagePreloader } from '~/common/PostImagePreloader'
import { useWindowSize } from '~/common/hooks/useWindowSize'

type CustomerActivityListProps = {
  postIds: string[]
  setPostExpanded: (value: boolean) => void
  loadMore?: () => void
  loadingMore?: boolean
  hasMore?: boolean
  loading: boolean
  error?: ApolloError
}
export const CustomerActivityList = ({
  postIds,
  setPostExpanded,
  loadMore,
  hasMore,
  loadingMore,
  loading,
  error,
}: CustomerActivityListProps) => {
  const { isCondensed } = useWindowSize()
  const [activeRows, setActiveRows] = useState<string[]>([])
  const [rowsExpanded, setRowsExpanded] = useState<Map<string, boolean>>(new Map<string, boolean>())

  const buttonRef = useRef<HTMLButtonElement>(null)

  const onSelect = (keys: string[]) => {
    setActiveRows(keys)
  }

  const clickShowMore = (e: React.MouseEvent) => {
    elementClicked(e, 'click-posts-show-more')
    loadMore?.()
    buttonRef?.current?.blur()
  }

  const rowExpanded = useCallback(
    (rowId: string, expanded: boolean) => {
      const rows: Map<string, boolean> = rowsExpanded ?? new Map()
      rows.set(rowId, expanded)
      setRowsExpanded(rows)

      if (expanded) {
        if (setPostExpanded) {
          setPostExpanded(true)
        }
      } else {
        if (Array.from(rowsExpanded.values()).includes(true)) {
          if (setPostExpanded) {
            setPostExpanded(true)
          }
        } else {
          if (setPostExpanded) {
            setPostExpanded(false)
          }
        }
      }
    },
    [rowsExpanded, setPostExpanded]
  )

  if (loading) return <div className={'list-container customer-activity-list loading'}>Loading...</div>
  if (!postIds || error) return null

  return (
    <>
      <div className={`list-container customer-activity-list ${isCondensed ? 'condensed' : ''}`}>
        {postIds.length > 0 ? (
          <>
            <PostImagePreloader postIds={postIds} />
            <Accordion alwaysOpen={true} flush className={'post-list'} activeKey={activeRows} onSelect={onSelect}>
              {postIds.map((postId, index) => (
                <CustomerActivityRow key={index} postId={postId ?? ''} rowExpanded={rowExpanded} />
              ))}
            </Accordion>
          </>
        ) : (
          <div className="section-empty">No recent activity.</div>
        )}
      </div>
      {loadingMore ? (
        <div className={'loading show-more-loading'}>Loading...</div>
      ) : (
        hasMore && (
          <div className="show-more-activity">
            <Button
              ref={buttonRef}
              onClick={clickShowMore}
              disabled={loadingMore}
              tabIndex={0}
              className={'show-more-button'}
            >
              Show more <img src={moreIcon} alt={'Show more'} />
            </Button>
          </div>
        )
      )}
    </>
  )
}
